'use client';

import { c as _c } from "react/compiler-runtime";
import { type DropdownMenuProps, DropdownMenu as SharedDropdownMenu } from '@shared/ui-components/dropdown-menu/dropdown-menu';
import { useContainerSpacingInline } from '../../utils/hooks/use-container-spacing-inline';
export const DropdownMenu = props => {
  const $ = _c(3);
  const containerPadding = useContainerSpacingInline();
  let t0;
  if ($[0] !== containerPadding || $[1] !== props) {
    t0 = <SharedDropdownMenu containerPadding={containerPadding} {...props} />;
    $[0] = containerPadding;
    $[1] = props;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};